import { supabase } from '@/lib/supabase';
import { listVerifiedPractitioners, type VerifiedPractitioner } from './api';

export type QiIntakeStatus =
  | 'draft' | 'pending_review' | 'pending_acceptance' | 'accepted'
  | 'changes_requested' | 'declined' | 'withdrawn';

export interface QiIntakeForm {
  practitioner_id: string;
  applicant_name: string;
  phone: string;
  address: string;
  emergency_contact_name: string;
  emergency_contact_phone: string;
  birth_date: string;
  residence_city: string;
  preferred_service_city: string;
  service_mode: string;
  service_stage: string;
  concerns_body: string;
  concerns_emotion: string;
  concerns_life: string;
  concerns_work: string;
  primary_problem: string;
  goals: string;
  history: string;
  medical_history: string;
  medications: string;
  allergies: string;
  preferred_times: string;
  applicant_notes: string;
}

export interface QiIntakeRequest extends QiIntakeForm {
  id: number;
  applicant_id: string;
  status: QiIntakeStatus;
  submitted_at: string | null;
  updated_at: string;
}

export const EMPTY_QI_INTAKE: QiIntakeForm = {
  practitioner_id: '', applicant_name: '', phone: '', address: '',
  emergency_contact_name: '', emergency_contact_phone: '', birth_date: '',
  residence_city: '', preferred_service_city: '', service_mode: 'either',
  service_stage: 'first_request',
  concerns_body: '', concerns_emotion: '', concerns_life: '', concerns_work: '',
  primary_problem: '', goals: '', history: '', medical_history: '',
  medications: '', allergies: '', preferred_times: '', applicant_notes: '',
};

export async function loadMyEditableIntake(): Promise<QiIntakeRequest | null> {
  const { data, error } = await supabase.from('qi_intake_requests').select('*')
    .in('status', ['draft', 'changes_requested']).order('updated_at', { ascending: false })
    .limit(1).maybeSingle();
  if (error) throw error;
  return data as QiIntakeRequest | null;
}

export async function saveMyIntake(
  id: number | null, form: QiIntakeForm, submit = false,
): Promise<QiIntakeRequest> {
  const { data, error } = await supabase.rpc('save_my_qi_intake', {
    p_id: id, p_payload: form, p_submit: submit,
  });
  if (error) throw error;
  return data as QiIntakeRequest;
}

export async function intakePractitioners(): Promise<VerifiedPractitioner[]> {
  return listVerifiedPractitioners();
}
